import DropdownV2 from "../../../../components/form_builder/elements/dropdown/DropdownV2.vue";
import { validateRequired } from "../../../../helpers/validation";

export default {
  componentName: "fb-dropdown-v2",
  component: DropdownV2,
  defaultAttrs: {
    properties: {
      label: "Label",
      options: [],
      description: "",
      value: "",
      required: false,
      hidden: false,
      multiselect: false,
      style: {},
      pickerBgColor: "",
      eFormEditable: true,
      includeOther: false,
      resetStoreValues: false,
      hideOnView: false,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    width: 100,
    template: ({ value }) => {
      if (value) {
        if (value.value == "Other") return value.otherValue;
        return value.value;
      }
      return value;
    }
  },
  getValueReport: value => {
    if (value) {
      if (value.value == "Other") return value.otherValue;
      return value.value;
    }
    return value;
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (
      properties.required &&
      (
        !value ||
        (!validateRequired(value.value) && !validateRequired(value.otherValue))
      )
    )
      errors.push("This field is required");
    return errors;
  }
};
